module.exports = __webpack_public_path__ + "img/bg.f8faed2d.png";